import { render, staticRenderFns } from "./AdminSettings.vue?vue&type=template&id=8ae27658&"
import script from "./AdminSettings.vue?vue&type=script&lang=ts&"
export * from "./AdminSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports